import EvaluationFlow from "../../../../flow/EvaluationFlow"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import { DecisionReason } from "../../../../../model/model"
import { InAppMessageEligibilityEvaluateResult } from "../InAppMessageEligibilityEvaluateResult"
import { InAppMessageEligibilityRemoteEvaluateRequest } from "../mode/remote/InAppMessageEligibilityRemoteEvaluateRequest"
import InAppMessageEligibilityFlowEvaluator from "./InAppMessageEligibilityFlowEvaluator"
import { InAppMessageLayoutEvaluateResponse } from "../../layout/InAppMessageLayoutEvaluateResponse"
import { InAppMessageLayoutRemoteEvaluateRequest } from "../../layout/mode/remote/InAppMessageLayoutRemoteEvaluateRequest"
import { InAppMessageLayoutRemoteEvaluator } from "../../layout/mode/remote/InAppMessageLayoutRemoteEvaluator"

export type InAppMessageEligibilityRemoteFlow = EvaluationFlow<
  InAppMessageEligibilityRemoteEvaluateRequest,
  InAppMessageEligibilityEvaluateResult
>

export interface InAppMessageEligibilityRemoteFlowEvaluator
  extends InAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest> {
  evaluate(
    request: InAppMessageEligibilityRemoteEvaluateRequest,
    context: EvaluatorContext,
    nextFlow: InAppMessageEligibilityRemoteFlow
  ): InAppMessageEligibilityEvaluateResult | undefined
}

export class OverrideInAppMessageEligibilityRemoteFlowEvaluator implements InAppMessageEligibilityRemoteFlowEvaluator {
  evaluate(
    request: InAppMessageEligibilityRemoteEvaluateRequest,
    context: EvaluatorContext,
    nextFlow: InAppMessageEligibilityRemoteFlow
  ): InAppMessageEligibilityEvaluateResult | undefined {
    if (request.inAppMessage.reason === DecisionReason.OVERRIDDEN) {
      return InAppMessageEligibilityEvaluateResult.eligible(DecisionReason.OVERRIDDEN)
    }

    return nextFlow.evaluate(request, context)
  }
}

export class IneligibleInAppMessageEligibilityRemoteFlowEvaluator
  implements InAppMessageEligibilityRemoteFlowEvaluator
{
  evaluate(
    request: InAppMessageEligibilityRemoteEvaluateRequest,
    context: EvaluatorContext,
    nextFlow: InAppMessageEligibilityRemoteFlow
  ): InAppMessageEligibilityEvaluateResult | undefined {
    if (!request.inAppMessage.isEligible) {
      return InAppMessageEligibilityEvaluateResult.ineligible(request.inAppMessage.reason)
    }

    return nextFlow.evaluate(request, context)
  }
}

export class LayoutResolveInAppMessageEligibilityRemoteFlowEvaluator
  implements InAppMessageEligibilityRemoteFlowEvaluator
{
  constructor(private readonly layoutEvaluator: InAppMessageLayoutRemoteEvaluator) {}

  evaluate(
    request: InAppMessageEligibilityRemoteEvaluateRequest,
    context: EvaluatorContext,
    nextFlow: InAppMessageEligibilityRemoteFlow
  ): InAppMessageEligibilityEvaluateResult | undefined {
    const layoutRequest = InAppMessageLayoutRemoteEvaluateRequest.of(
      request.workspace,
      request.user,
      request.inAppMessage.layout,
      request.scope
    )
    const layoutResponse = this.layoutEvaluator.evaluate(layoutRequest, EvaluatorContext.create())
    context.set(InAppMessageLayoutEvaluateResponse, layoutResponse)

    return nextFlow.evaluate(request, context)
  }
}
